import React from "react";
import styled from "styled-components";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogProps, Link } from "@material-ui/core";
import { Button } from "js/Components/Button";
import { getStaticUrl } from "js/config";
import { openTeamUpgrade } from "js/core/utilities/externalLinks";
import { defaultText, largeTitle } from "js/textStyles";
import { themeColors } from "js/react/sharedStyles";

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        padding: 20px 30px;
        border-radius: 5px;
        user-select: none;
        width: 550px;
    }
`;

const StyledDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding: 0px;
    }

    h2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        ${largeTitle}
        font-size: 20px;
        letter-spacing: 0;
        color: #333;

        p {
            margin-top: 10px;
            ${defaultText}
            color: ${themeColors.mediumGray};
    }
`;

const StyledDialogLogo = styled.img`
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
`;

const StyledDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        padding: 0px;
        justify-content: flex-end;        
    }
`;

interface GuestWorkspaceDialogProps extends DialogProps {
    closeDialog?: () => void;
}

const GuestWorkspaceDialog = (props: GuestWorkspaceDialogProps) => {
    const { closeDialog } = props;

    return (
        <StyledDialog open={true} onClose={closeDialog}>
            <StyledDialogTitle>
                <StyledDialogLogo src={getStaticUrl("/images/beautifulai-logos/beautifulai-guest-logo.svg")} alt="logo" />
                You are a guest in this workspace
                <p>As a guest you can collaborate, but can't create new presentations.</p>
                <p>To unlock this feature, reach out to the workspace owner to request an upgrade, or <Link onClick={openTeamUpgrade}>create a new workspace</Link>.</p>
            </StyledDialogTitle>
            <StyledDialogActions>
                <Button unframed color={themeColors.ui_blue} onClick={closeDialog}>Got it</Button>
            </StyledDialogActions>
        </StyledDialog>
    );
};

export default GuestWorkspaceDialog;
